export enum RouteFromQuery {
    Checkout = 'checkout',
    Confirmation = 'confirmation',
    Dates = 'dates',
    Properties = 'hotels',
    Rates = 'rates',
    SpaceCategories = 'rooms',
    Summary = 'summary',
}
